var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatBubble = function SvgChatBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "A6A6477D-2171-4927-AC59-52EBCABE5E8D")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Listing---Provider-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "experience-Provider-Details-expanded",
    transform: "translate(-250.000000, -477.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "about",
    transform: "translate(200.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(16.000000, 338.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Communication-/-Group-chat-circle",
    transform: "translate(34.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,8 C12.8659932,8 16,10.6862915 16,14 C16,17.3137085 12.8659932,20 9,20 C8.40698735,20 7.83119771,19.9367939 7.28130039,19.8178126 L4.31324522,21.5304877 C4.19786847,21.5971005 4.06067835,21.6149134 3.93211595,21.5799738 C3.66563921,21.5075531 3.5083257,21.2328225 3.5807464,20.9663457 L3.5807464,20.9663457 L4.27072192,18.4235968 C2.87503225,17.3267428 2,15.7509606 2,14 C2,10.6862915 5.13400675,8 9,8 Z",
    id: "Combined-Shape",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3926714,3 C18.594083,3 22,5.6862915 22,9 C22,9.8435529 21.7792859,10.6464472 21.3809207,11.3747185 L22.4156702,15.1836902 C22.4880908,15.4501669 22.3307773,15.7248976 22.0643006,15.7973183 C21.9357382,15.8322578 21.7985481,15.814445 21.6831713,15.7478322 L18.6291221,13.9842623 C18.3017451,14.1577009 17.9563414,14.3116062 17.5955944,14.443862 C17.6041626,14.312894 17.6080892,14.1810815 17.6080892,14.0484765 C17.6080892,9.84706494 13.6663841,6.44114791 8.80404458,6.44114791 C8.34647033,6.44114791 7.89704913,6.47131036 7.4582987,6.52945976 C8.65213375,4.44804225 11.3079974,3 14.3926714,3 Z",
    id: "Combined-Shape",
    fill: "#ADB5BD"
  }))))))));
};
export default SvgChatBubble;